import React, { type FC } from 'react'
import './SkeletonLoader.scss'

const SkeletonPlaceholder: FC = () => {
  return <div className='skeleton' />
}

export default SkeletonPlaceholder
